(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aerre-giveaway-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGiveaways = (scope = document) => {
      const roots = [...scope.querySelectorAll('[data-aerre-giveaway]')];
      if (scope.matches?.('[data-aerre-giveaway]')) roots.unshift(scope);
      roots.forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        const dialog = root.querySelector('[data-signup-dialog]');
        const fieldsPanel = root.querySelector('[data-signup-fields]');
        const successPanel = root.querySelector('[data-signup-success]');
        const signupInputs = [...root.querySelectorAll('[data-signup-input]')];
        const signupError = root.querySelector('[data-signup-error]');
        const calculator = root.querySelector('[data-calculator]');
        const spendInput = root.querySelector('[data-eligible-spend]');
        const countOutput = root.querySelector('[data-entry-count]');
        const estimate = root.querySelector('[data-estimate-text]');
        const orderButton = root.querySelector('[data-preview-order]');
        const orderPanel = root.querySelector('[data-order-confirmation]');
        let opener = null;
        let eligibleCents = 8000;
        let entryCount = 20;
        const formatter = new Intl.NumberFormat(root.dataset.locale || 'en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const getEntries = (cents) => cents <= 0 ? 0 : cents < 8000 ? 10 : cents < 11000 ? 20 : 30;
        const resetSignup = () => {
          signupInputs.forEach((input) => {
            if (input.type === 'checkbox') input.checked = false;
            else input.value = '';
          });
          signupError.hidden = true;
          fieldsPanel.hidden = false;
          successPanel.hidden = true;
        };
        const closeSignup = () => {
          if (dialog.open) dialog.close();
          resetSignup();
          opener?.focus({ preventScroll: true });
        };
        root.querySelectorAll('[data-open-signup]').forEach((button) => button.addEventListener('click', () => {
          opener = button;
          resetSignup();
          dialog.showModal();
          signupInputs[0].focus({ preventScroll: true });
        }));
        root.querySelectorAll('[data-close-signup]').forEach((button) => button.addEventListener('click', closeSignup));
        dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeSignup(); });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeSignup();
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]')].filter((element) => !element.closest('[hidden]') && element.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (!first) return;
          if (event.shiftKey && (document.activeElement === first || document.activeElement === successPanel)) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || document.activeElement === successPanel)) { event.preventDefault(); first.focus(); }
        });
        root.querySelector('[data-preview-signup]').addEventListener('click', () => {
          signupInputs.filter((input) => input.type !== 'checkbox').forEach((input) => { input.value = input.value.trim(); });
          const invalid = signupInputs.find((input) => !input.checkValidity());
          if (invalid) { signupError.hidden = false; invalid.focus(); invalid.reportValidity(); return; }
          signupError.hidden = true;
          fieldsPanel.hidden = true;
          successPanel.hidden = false;
          successPanel.focus({ preventScroll: true });
          dialog.scrollTop = 0;
        });
        root.querySelector('[data-success-purchase]').addEventListener('click', () => {
          closeSignup();
          spendInput.focus({ preventScroll: true });
          calculator.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
        const updateCalculator = () => {
          orderPanel.hidden = true;
          const amount = Number(spendInput.value);
          const valid = spendInput.value.trim() !== '' && Number.isFinite(amount) && amount >= 0 && spendInput.checkValidity();
          spendInput.setAttribute('aria-invalid', String(!valid));
          estimate.classList.toggle('is-error', !valid);
          orderButton.disabled = !valid;
          if (!valid) { countOutput.value = '0'; estimate.textContent = calculator.dataset.invalid; return; }
          eligibleCents = Math.round(amount * 100);
          entryCount = getEntries(eligibleCents);
          countOutput.value = String(entryCount);
          estimate.textContent = eligibleCents === 0 ? calculator.dataset.zero : calculator.dataset.estimate.replace('[amount]', formatter.format(eligibleCents / 100)).replace('[entries]', String(entryCount));
        };
        spendInput.addEventListener('input', updateCalculator);
        root.querySelectorAll('[data-spend-sample]').forEach((button) => button.addEventListener('click', () => { spendInput.value = button.dataset.spendSample; updateCalculator(); }));
        orderButton.addEventListener('click', () => {
          updateCalculator();
          if (orderButton.disabled) return;
          root.querySelector('[data-order-value]').textContent = formatter.format(eligibleCents / 100);
          root.querySelector('[data-order-entries]').textContent = String(entryCount);
          orderPanel.hidden = false;
          orderPanel.focus({ preventScroll: true });
          orderPanel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        });
        updateCalculator();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeGiveaways(), { once: true });
    else initializeGiveaways();
    document.addEventListener('shopify:section:load', (event) => initializeGiveaways(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aerre-job-application"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aerre-job-application')) {
  customElements.define('aerre-job-application', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-job-form]');
      if (!this.form) return;
      try { this.config = JSON.parse(this.querySelector('[data-aerre-job-config]').textContent); } catch (_) { return; }
      this.startedAt = Date.now();
      this.fieldNodes = [...this.querySelectorAll('[data-job-field]')];
      this.panels = [...this.querySelectorAll('[data-step-panel]')].filter(panel => panel.dataset.stepPanel === 'review' || panel.querySelector('[data-job-field]'));
      this.index = 0;
      this.controls = this.querySelector('[data-job-controls]');
      this.back = this.querySelector('[data-job-back]');
      this.next = this.querySelector('[data-job-next]');
      this.send = this.querySelector('[data-job-submit]');
      this.errorBox = this.querySelector('[data-job-errors]');
      this.status = this.querySelector('[data-job-status]');
      this.nextHTML = this.next.innerHTML;
      this.sendHTML = this.send.innerHTML;
      this.config.fields.forEach(field => {
        if (field.source === 'retail_stores') field.optionGroups = Object.fromEntries(field.options.map(option => [option, option.split(' - ')[2]]));
      });
      const keys = this.config.fields.map(field => field.id);
      const types = ['text', 'email', 'tel', 'url', 'textarea', 'select', 'radio', 'checkboxes', 'checkbox', 'date', 'file'];
      this.validConfig = /^[a-z][a-z0-9_-]{0,63}$/.test(this.config.formId) && keys.length > 0 && new Set(keys).size === keys.length && this.config.fields.filter(field => field.type === 'file').length <= 1 && this.config.fields.every(field => /^[a-z][a-z0-9_]{0,63}$/.test(field.id) && field.label.trim() && field.label.length <= 240 && types.includes(field.type) && Number.isInteger(field.maxLength) && field.maxLength >= 1 && field.maxLength <= 5000 && field.options.length <= 100 && field.options.every(option => option.length <= 240) && (!['select', 'radio', 'checkboxes'].includes(field.type) || ((field.options.length > 0 || field.source === 'retail_stores') && new Set(field.options).size === field.options.length)));
      this.fieldMap = new Map(this.config.fields.map(field => [field.id, field]));
      this.nodeMap = new Map(this.fieldNodes.map(node => [node.dataset.fieldKey, node]));
      this.validConfig = this.validConfig && this.config.fields.every(field => {
        const visited = new Set([field.id]);
        let current = field;
        while (current.condition) {
          const parent = this.fieldMap.get(current.condition.field);
          if (!parent || visited.has(parent.id) || !['select', 'radio'].includes(parent.type) || (current.condition.value && !parent.options.includes(current.condition.value))) return false;
          visited.add(parent.id);
          current = parent;
        }
        return !field.optionGroups || (field.type === 'checkboxes' && field.condition && field.options.every(option => this.fieldMap.get(field.condition.field).options.includes(field.optionGroups[option])));
      });
      try { const url = new URL(this.config.endpoint); this.validEndpoint = url.protocol === 'https:' && url.hostname === 'script.google.com' && /^\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(url.pathname); } catch (_) { this.validEndpoint = false; }
      this.canSend = this.validConfig && this.validEndpoint && this.config.enabled;
      this.querySelector('[data-job-unavailable]').hidden = this.canSend;
      this.querySelector('[data-job-editor-warning]').hidden = this.validConfig || !this.hasAttribute('data-design-mode');
      this.form.addEventListener('submit', event => event.preventDefault());
      this.back.addEventListener('click', () => this.showStep(this.index - 1, true));
      this.next.addEventListener('click', () => { if (this.validate(this.panels[this.index])) this.showStep(this.index + 1, true); });
      this.send.addEventListener('click', () => this.submitApplication());
      this.form.addEventListener('input', event => {
        const field = event.target.closest('[data-job-field]');
        if (field) this.clearFieldError(field);
      });
      this.form.addEventListener('change', event => {
        this.updateConditions();
        if (event.target.type === 'file') {
          const field = event.target.closest('[data-job-field]');
          field.querySelector('[data-remove-file]').hidden = !event.target.files.length;
          this.clearFieldError(field);
        }
      });
      this.querySelectorAll('[data-remove-file]').forEach(button => button.addEventListener('click', () => {
        const input = button.closest('[data-job-field]').querySelector('input');
        input.value = '';
        button.hidden = true;
        this.clearFieldError(button.closest('[data-job-field]'));
        input.focus();
      }));
      this.blockSelect = event => {
        const field = this.fieldNodes.find(node => node.dataset.blockId === event.detail.blockId);
        if (field) this.showStep(this.panels.indexOf(field.closest('[data-step-panel]')), false);
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
      this.controls.disabled = false;
      if (this.validConfig) {
        this.fieldNodes.forEach(node => {
          const field = this.fieldConfig(node);
          if (field.source !== 'retail_stores') return;
          const list = node.querySelector('.aerre-job__option-list');
          const legendId = node.querySelector('legend').id;
          const baseId = legendId.replace(/-legend$/, '');
          list.replaceChildren();
          field.options.forEach((option, index) => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            const span = document.createElement('span');
            label.className = 'aerre-job__choice';
            input.type = 'checkbox';
            input.name = baseId;
            input.id = baseId + '-' + (index + 1);
            input.value = option;
            input.setAttribute('aria-describedby', baseId + '-help ' + baseId + '-error');
            label.htmlFor = input.id;
            span.textContent = option.split(' - ').slice(3).join(' - ');
            label.append(input, span);
            list.append(label);
          });
        });
        this.updateConditions();
      }
      this.showStep(0, false);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
      if (this.controller) this.controller.abort();
    }
    showStep(index, focus) {
      if (this.pending || index < 0 || index >= this.panels.length) return;
      this.index = index;
      const active = this.panels[index];
      this.querySelectorAll('[data-step-panel]').forEach(panel => { panel.hidden = panel !== active; });
      this.querySelectorAll('[data-progress-step]').forEach(item => {
        const position = this.panels.findIndex(panel => panel.dataset.stepPanel === item.dataset.progressStep);
        item.hidden = position === -1;
        item.classList.toggle('is-complete', position < index);
        item.toggleAttribute('data-active', position === index);
        if (position === index) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
        if (position >= 0) item.firstElementChild.textContent = String(position + 1).padStart(2, '0');
      });
      const review = active.dataset.stepPanel === 'review';
      this.back.hidden = index === 0;
      this.next.hidden = review;
      this.send.hidden = !review;
      this.send.disabled = !this.canSend;
      this.next.innerHTML = this.nextHTML;
      if (!review && this.panels[index + 1].dataset.stepPanel === 'review') this.next.firstChild.textContent = this.config.copy.review + ' ';
      this.errorBox.hidden = true;
      this.status.textContent = '';
      if (review) this.renderReview();
      if (focus) active.querySelector('h2').focus();
    }
    fieldConfig(node) { return this.config.fields.find(field => field.id === node.dataset.fieldKey); }
    valueFor(node, field) {
      if (field.type === 'file') return node.querySelector('input').files[0] || '';
      if (field.type === 'checkboxes') return [...node.querySelectorAll('input:checked')].map(input => input.value);
      if (field.type === 'radio' || field.type === 'checkbox') return node.querySelector('input:checked')?.value || '';
      return node.querySelector('input, textarea, select')?.value.trim() || '';
    }
    isActive(field) {
      if (!field.condition) return true;
      const parent = this.fieldMap.get(field.condition.field);
      const value = this.valueFor(this.nodeMap.get(parent.id), parent);
      return this.isActive(parent) && parent.options.includes(value) && (!field.condition.value || value === field.condition.value);
    }
    updateConditions() {
      if (!this.validConfig) return;
      this.fieldNodes.forEach(node => {
        const field = this.fieldConfig(node);
        const active = this.isActive(field);
        node.hidden = !active;
        this.clearFieldError(node);
        node.querySelectorAll('input, textarea, select').forEach(input => {
          const groupMatches = !field.optionGroups || field.optionGroups[input.value] === this.valueFor(this.nodeMap.get(field.condition.field), this.fieldMap.get(field.condition.field));
          input.disabled = !active || !groupMatches;
          if (field.optionGroups) input.closest('label').hidden = !groupMatches;
          if (input.disabled) {
            if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
            else input.value = '';
          }
        });
        const empty = node.querySelector('[data-locations-empty]');
        if (empty) empty.textContent = this.config.copy.locationsEmpty;
        if (empty) empty.hidden = !active || !!node.querySelector('input:not(:disabled)');
      });
      this.errorBox.hidden = true;
    }
    clearFieldError(node) {
      node.querySelector('[data-field-error]').hidden = true;
      node.querySelectorAll('[aria-invalid]').forEach(input => input.removeAttribute('aria-invalid'));
    }
    validate(panel) {
      const errors = [];
      [...panel.querySelectorAll('[data-job-field]')].forEach(node => {
        this.clearFieldError(node);
        const field = this.fieldConfig(node);
        if (!field || !this.isActive(field)) return;
        const value = this.valueFor(node, field);
        const input = node.querySelector('input:not(:disabled), textarea:not(:disabled), select:not(:disabled)') || node.querySelector('legend');
        let message = '';
        if (field.source === 'retail_stores' && !node.querySelector('input:not(:disabled)')) message = this.config.copy.locationsEmpty;
        else if (field.required && (!value || value.length === 0)) message = this.config.copy.required;
        else if (field.type === 'file' && value && (value.size > field.maxBytes || value.size === 0)) message = this.config.copy.fileSize;
        else if (typeof value === 'string' && value.length > field.maxLength) message = this.config.copy.length;
        else if (value && field.type === 'email' && input.validity.typeMismatch) message = this.config.copy.email;
        else if (value && field.type === 'url') {
          try { if (!['http:', 'https:'].includes(new URL(value).protocol)) message = this.config.copy.url; } catch (_) { message = this.config.copy.url; }
        } else if (value && input.validity?.badInput) message = this.config.copy.invalid;
        if (message) {
          const error = node.querySelector('[data-field-error]');
          error.textContent = message;
          error.hidden = false;
          node.querySelectorAll('input, textarea, select').forEach(control => control.setAttribute('aria-invalid', 'true'));
          errors.push({ node, field, message, input });
        }
      });
      this.errorBox.hidden = errors.length === 0;
      const list = this.querySelector('[data-job-error-list]');
      list.replaceChildren();
      if (errors.length) {
        this.querySelector('[data-job-error-copy]').textContent = this.config.copy.errorSummary;
        errors.forEach(error => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + error.input.id;
          link.textContent = error.field.label + ': ' + error.message;
          link.addEventListener('click', event => { event.preventDefault(); error.input.focus(); });
          item.append(link);
          list.append(item);
        });
        this.errorBox.focus();
      }
      return errors.length === 0;
    }
    renderReview() {
      const review = this.querySelector('[data-job-review]');
      review.replaceChildren();
      this.fieldNodes.forEach(node => {
        const field = this.fieldConfig(node);
        if (!field || !this.isActive(field)) return;
        let value = this.valueFor(node, field);
        if (field.type === 'file' && value) value = value.name;
        if (Array.isArray(value)) value = value.map(option => field.source === 'retail_stores' ? option.split(' - ').slice(3).join(' - ') : option).join(', ');
        if (field.type === 'checkbox' && value) value = this.config.copy.yes;
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        const edit = document.createElement('button');
        term.textContent = field.label;
        description.textContent = value || this.config.copy.notProvided;
        edit.type = 'button';
        edit.className = 'aerre-job__edit';
        edit.textContent = this.config.copy.edit;
        edit.setAttribute('aria-label', this.config.copy.edit + ': ' + field.label);
        edit.addEventListener('click', () => {
          this.showStep(this.panels.indexOf(node.closest('[data-step-panel]')), false);
          node.querySelector('input, textarea, select')?.focus();
        });
        row.append(term, description, edit);
        review.append(row);
      });
    }
    async submitApplication() {
      if (this.pending || !this.canSend) return;
      for (let index = 0; index < this.panels.length - 1; index++) {
        if (!this.validate(this.panels[index])) { this.showStep(index, false); this.validate(this.panels[index]); return; }
      }
      const answers = Object.create(null);
      const requestId = crypto.randomUUID ? crypto.randomUUID() : '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, digit => (Number(digit) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(digit) / 4).toString(16));
      const payload = { formId: this.config.formId, requestId, startedAt: this.startedAt, website: this.querySelector('[data-job-honeypot]').value, answers };
      this.pending = true;
      this.controls.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.send.textContent = this.config.copy.pending;
      this.status.textContent = this.config.copy.pending;
      this.errorBox.hidden = true;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 90000);
      try {
        for (const node of this.fieldNodes) {
          const field = this.fieldConfig(node);
          if (!this.isActive(field)) continue;
          const value = this.valueFor(node, field);
          if (field.type === 'file') {
            if (value) {
              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(String(reader.result).split(',')[1]);
                reader.onerror = () => reject(new Error('file_read_failed'));
                reader.onabort = () => reject(new Error('file_read_failed'));
                reader.readAsDataURL(value);
              });
              answers[field.id] = { name: value.name, mimeType: value.type || 'application/octet-stream', base64 };
            }
          } else answers[field.id] = value;
        }
        const response = await fetch(this.config.endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), credentials: 'omit', signal: this.controller.signal });
        if (!response.ok) throw new Error('submission_failed');
        const result = await response.json();
        if (result.ok === false && result.requestId === requestId && result.fieldErrors && typeof result.fieldErrors === 'object') {
          const errors = Object.entries(result.fieldErrors).filter(([key, message]) => typeof message === 'string' && this.fieldNodes.some(node => node.dataset.fieldKey === key));
          if (errors.length) {
            this.pending = false;
            const first = this.fieldNodes.find(node => node.dataset.fieldKey === errors[0][0]);
            this.showStep(this.panels.indexOf(first.closest('[data-step-panel]')), false);
            const list = this.querySelector('[data-job-error-list]');
            list.replaceChildren();
            this.querySelector('[data-job-error-copy]').textContent = this.config.copy.errorSummary;
            errors.forEach(([key, message]) => {
              const node = this.fieldNodes.find(fieldNode => fieldNode.dataset.fieldKey === key);
              const error = node.querySelector('[data-field-error]');
              error.textContent = message;
              error.hidden = false;
              node.querySelectorAll('input, textarea, select').forEach(control => control.setAttribute('aria-invalid', 'true'));
              const input = node.querySelector('input:not(:disabled), textarea:not(:disabled), select:not(:disabled)') || node.querySelector('legend');
              const item = document.createElement('li');
              const link = document.createElement('a');
              link.href = '#' + input.id;
              link.textContent = this.fieldConfig(node).label + ': ' + message;
              link.addEventListener('click', event => {
                event.preventDefault();
                this.showStep(this.panels.indexOf(node.closest('[data-step-panel]')), false);
                input.focus();
              });
              item.append(link);
              list.append(item);
            });
            this.errorBox.hidden = false;
            this.errorBox.focus();
            return;
          }
        }
        if (result.ok !== true || result.requestId !== requestId || typeof result.applicationId !== 'string' || !result.applicationId.trim()) throw new Error('submission_unconfirmed');
        this.querySelector('[data-job-flow]').hidden = true;
        const success = this.querySelector('[data-job-success]');
        success.hidden = false;
        this.querySelector('[data-job-reference]').textContent = this.config.copy.reference + ' ' + result.applicationId;
        this.form.reset();
        success.focus();
      } catch (_) {
        this.errorBox.hidden = false;
        this.querySelector('[data-job-error-copy]').textContent = this.config.copy.failure;
        this.querySelector('[data-job-error-list]').replaceChildren();
        this.status.textContent = '';
        this.errorBox.focus();
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.controls.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.send.innerHTML = this.sendHTML;
        this.send.disabled = !this.canSend;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const countdowns = new WeakMap();
    const counterKey = 'my-counter';
    const sectionSelector = '.shopify-section--announcement-bar';

    function startCountdown(section) {
      countdowns.get(section)?.();
      const targets = Array.from(section.querySelectorAll('#countdownDiv'));
      if (!targets.length) return;

      let storage;
      let remaining = 3599;
      let timer;

      try {
        storage = window.sessionStorage;
        const saved = Number.parseInt(storage.getItem(counterKey), 10);
        if (Number.isFinite(saved) && saved >= 0) remaining = saved;
      } catch {
        storage = null;
      }

      function stopCountdown() {
        clearInterval(timer);
        countdowns.delete(section);
      }

      function updateCountdown() {
        const connectedTargets = targets.filter((target) => target.isConnected);
        if (!section.isConnected || !connectedTargets.length) {
          stopCountdown();
          return false;
        }

        const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        connectedTargets.forEach((target) => {
          target.textContent = `00h : ${minutes}m : ${seconds}s`;
        });

        if (remaining === 0) {
          connectedTargets.forEach((target) => {
            const message = target.closest('#countdown-message');
            if (message) message.style.display = 'none';
          });
          try { storage?.removeItem(counterKey); } catch { storage = null; }
          stopCountdown();
          return false;
        }

        remaining -= 1;
        try { storage?.setItem(counterKey, remaining); } catch { storage = null; }
        return true;
      }

      countdowns.set(section, stopCountdown);
      if (updateCountdown()) timer = setInterval(updateCountdown, 1000);
    }

    function initializeCountdowns() {
      document.querySelectorAll(sectionSelector).forEach(startCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCountdowns, { once: true });
    } else {
      initializeCountdowns();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches(sectionSelector)) startCountdown(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      countdowns.get(event.target)?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-video-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homepage-media-content')) {
    customElements.define('homepage-media-content', class extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-homepage-copy]'));
        this.dots = this.querySelector('page-dots');
        if (!this.dots || this.panels.length < 2) return;
        this.onChange = event => this.showPanel(event.detail.index);
        this.onBlockSelect = event => {
          const panel = event.target.closest('[data-homepage-copy]');
          const index = this.panels.indexOf(panel);
          if (index < 0) return;
          this.editorSelected = true;
          this.showPanel(index);
          this.style.setProperty('--section-animation-play-state', 'paused');
        };
        this.onBlockDeselect = () => {
          this.editorSelected = false;
          this.style.setProperty('--section-animation-play-state', this.isVisible ? 'running' : 'paused');
        };
        this.addEventListener('page-dots:changed', this.onChange);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.observer = new IntersectionObserver(entries => {
          this.isVisible = entries[0].isIntersecting;
          this.style.setProperty('--section-animation-play-state', this.isVisible && !this.editorSelected ? 'running' : 'paused');
        });
        this.observer.observe(this);
      }
      showPanel(index) {
        if (!this.panels[index]) return;
        this.panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; });
        this.dots.selectedIndex = index;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('page-dots:changed', this.onChange);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
